import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.object.assign.js";
import UA from '../ua';
import Env from '../env';
import Platform from '../platform';
import Url from './url';
import KNB from '@dp/knb';
import Cookie from './cookie';
import ACTIVITY_TAG from '../config/activityTag';
import { TJBridge } from '../platform/tengjing';
import parseUrl from 'url-parse';
import KNBCore from '@mtfe/knb-core';
function isCrawlEnabled(url) {
  // lion api 白名单
  var lionApiConfig = localStorage.getItem('limitApiLionConfig');
  var lionApiConfigArr = lionApiConfig ? lionApiConfig.split(',') : [];
  var lionApiRegex = new RegExp(lionApiConfigArr.join('|'));

  // 前端路由白名单: 详情页、票档页 旧选座分区页、旧选座页、新选座页、确认订单页。
  var limitRoutes = ['/detail', '/ticket-level', '/movieshoworder/select-seats.html', '/myshowfe/trade/seat', '/movieshoworder/pre-order.html'];
  var limitRouterRegex = new RegExp(limitRoutes.join('|'));
  return lionApiConfigArr.length && lionApiRegex.test(url) || limitRouterRegex.test(location.href);
}
function isUseNewWebviewForSSL(url) {
  var IS_DETAIL_PAGE = url.includes('#/detail/');
  var IS_TICKETLEVEL_PAGE = url.includes('#/ticket-level');
  var IS_PREORDER_PAGE = url.includes('/pre-order');
  return IS_DETAIL_PAGE || IS_TICKETLEVEL_PAGE || IS_PREORDER_PAGE;
}
function compareVersions(version1, version2) {
  // 将版本号拆分为数组
  var v1 = version1.split('.').map(Number);
  var v2 = version2.split('.').map(Number);
  // 获取最长的版本号长度
  var maxLength = Math.max(v1.length, v2.length);
  // 循环比较每一部分的版本号
  for (var i = 0; i < maxLength; i++) {
    var num1 = v1[i] || 0; // 如果v1长度不够，补0
    var num2 = v2[i] || 0; // 如果v2长度不够，补0
    if (num1 > num2) {
      return true;
    } else if (num1 < num2) {
      return false;
    }
  }
  // 如果所有部分都相等，返回true
  return true;
}
var KNBP = KNB.getPromiseInstance();
var urlPerfix = Platform.urlPerfix,
  _Platform$linkMap = Platform.linkMap,
  linkMap = _Platform$linkMap === void 0 ? {} : _Platform$linkMap;
var isProduct = Env.isProduct,
  isPpe = Env.isPpe,
  isLocal = Env.isLocal;
var showUrlRegx = /\/(myshow|movieshow|movieshowlist|movieshoworder|selfsale)\/?/;
export var getUrl = function getUrl(url) {
  url = url.trim();

  // if (!/^\//.test(url)) url = raletiveUrlCover(url)

  var _Url$parse = Url.parse(url),
    uri = _Url$parse.uri,
    hash = _Url$parse.hash,
    query = _Url$parse.query;

  // 兼容运营位置以前运营用乱带fromTag的问题
  if (query) {
    var activityTag = query[ACTIVITY_TAG.STATS_TAG] || query[ACTIVITY_TAG.FROM_TAG];
    if (query[ACTIVITY_TAG.FROM_TAG]) delete query[ACTIVITY_TAG.FROM_TAG];
    if (activityTag) query[ACTIVITY_TAG.STATS_TAG] = activityTag;
  }
  /** 灰度测试专用 */
  var isGray = location.search.includes('isshowgray=true');
  if (isGray) query.isshowgray = true;
  var isGray2 = location.search.includes('isshow2gray=true');
  if (isGray2) query.isshow2gray = true;
  /** 灰度测试专用 */
  /** 工行专用 */
  var isICBC = location.search.includes('sellChannel=35');
  if (isICBC) query.sellChannel = 35;

  // 演出相关路径 需要特殊处理， 以处理路径映射 及 fromTag 问题等
  if (showUrlRegx.test(uri)) {
    // 携带 fromTag
    var fromTag = Url.getQuery('fromTag') || Url.getQuery('utm_source') || Url.getHashQuery('utm_source');
    if (fromTag) query.fromTag = query.utm_source = fromTag;

    // cookie 中含有 ACTIVITY_TAG.STATS_TAG 需要带到下个链接
    var utmContent = '';
    var utmCookie = Cookie.get('_lx_utm');
    if (utmCookie) {
      var utm = Url.parseQuery(utmCookie);
      Object.keys(utm).forEach(function (key) {
        if (key === ACTIVITY_TAG.STATS_TAG) {
          utmContent = utm[key];
        }
      });
    }
    if (utmContent && !query[ACTIVITY_TAG.STATS_TAG]) query[ACTIVITY_TAG.STATS_TAG] = utmContent;

    // 清理前缀
    uri = uri.replace(/^(.*\.com\/app\/)/, '/');

    // 判断是否包含地址映射
    if (linkMap[uri]) uri = linkMap[uri];

    // 替换域名路径替换域名路径
    if (/^https?/.test(uri)) {
      url = Url.stringify(uri, query, hash);
    } else {
      url = Url.stringify(urlPerfix.replace(/[?#/&]$/, '') + uri, query, hash);
    }
    if (!/^https?/.test(url)) url = location.protocol + url;
  }
  if (url.includes('/myshowfe')) {
    url = url.replace(/\/app|\/qqw/, '');
  }
  if (Platform.sellChannel === 13 && url.includes('qqw/confirm')) {
    // M站渠道 --  新选座页跳下单页 url带上utm_source
    var _fromTag = Url.getQuery('fromTag') || Url.getQuery('utm_source') || Url.getHashQuery('utm_source');
    if (_fromTag) {
      var _Url$parse2 = Url.parse(url),
        _uri = _Url$parse2.uri,
        _hash = _Url$parse2.hash,
        _query = _Url$parse2.query;
      _query.fromTag = _query.utm_source = _fromTag;
      url = Url.stringify(_uri, _query, _hash);
    }
  }
  return url;
};
var redirect = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var options,
      IS_NEW_CALENDAR_PAGE,
      IS_SHARE_ORDER_PAGE,
      IS_SHOW_HOME_PAGE,
      IS_TICKET_STRATEGY_PAGE,
      IS_PRE_TICKET_V2_PAGE,
      jump,
      _blank,
      unFormate,
      isICBC,
      _Url$parse3,
      uri,
      hash,
      query,
      isGray,
      _Url$parse4,
      _uri2,
      _hash2,
      _query2,
      isGray2,
      _Url$parse5,
      _uri3,
      _hash3,
      _query3,
      IS_WXAPP_MEITUAN_PINCHANG,
      wxMtWebviewUrl,
      result,
      _miniUrl,
      _miniUrl2,
      _miniUrl3,
      _miniUrl4,
      _Url$parse6,
      _uri4,
      _hash4,
      _query4,
      queryStr,
      qs,
      _queryStr,
      _url,
      aEl,
      _url2,
      _aEl,
      _url3,
      _aEl2,
      _url4,
      _aEl3,
      _url5,
      _aEl4,
      _url6,
      _aEl5,
      lionStoreMyWebviewConfig,
      a,
      needWkWebview,
      _lionStoreMyWebviewConfig,
      _a,
      _a2,
      urlObj,
      _a3,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
            jump: false,
            _blank: true
          };
          IS_NEW_CALENDAR_PAGE = url.includes('/myshow/#/new-calendar');
          IS_SHARE_ORDER_PAGE = url.includes('/myshowfe/trade/share-order');
          IS_SHOW_HOME_PAGE = url === '/myshow/index.html';
          IS_TICKET_STRATEGY_PAGE = url.includes('/myshow/#/ticket-strategy') || url.includes('/myshow/index.html#/ticket-strategy');
          IS_PRE_TICKET_V2_PAGE = url.includes('myshow/#/pre-ticket-v2') || url.includes('/myshow/index.html#/pre-ticket-v2');
          jump = options.jump, _blank = options._blank, unFormate = options.unFormate;
          url = unFormate ? url : getUrl(url);
          if (isLocal) {
            url = url.replace('/app/myshow', '');
          }
          if (isProduct) {
            url = url.replace('i.test.maoyan.com', 'i.maoyan.com');
          }
          /** 工行专用 */
          isICBC = location.search.includes('sellChannel=35');
          if (isICBC) {
            _Url$parse3 = Url.parse(url), uri = _Url$parse3.uri, hash = _Url$parse3.hash, query = _Url$parse3.query;
            query.sellChannel = 35;
            url = Url.stringify(uri, query, hash);
          }

          /** 灰度测试专用 */
          isGray = location.search.includes('isshowgray=true');
          if (isGray) {
            _Url$parse4 = Url.parse(url), _uri2 = _Url$parse4.uri, _hash2 = _Url$parse4.hash, _query2 = _Url$parse4.query;
            _query2.isshowgray = true;
            url = Url.stringify(_uri2, _query2, _hash2);
          }
          isGray2 = location.search.includes('isshow2gray=true');
          if (isGray2) {
            _Url$parse5 = Url.parse(url), _uri3 = _Url$parse5.uri, _hash3 = _Url$parse5.hash, _query3 = _Url$parse5.query;
            _query3.isshow2gray = true;
            url = Url.stringify(_uri3, _query3, _hash3);
          }
          /** 灰度测试专用 */
          if (!UA.IS_TENGJING) {
            _context.next = 18;
            break;
          }
          return _context.abrupt("return", TJBridge.openWebview({
            url: url,
            jump: jump
          }));
        case 18:
          // 工行
          if (UA.IS_SHENZHEN_ICBC) {
            location.href = url;
          }

          // 美团小程序 和美团拼场小程序 直接新开webview页面
          IS_WXAPP_MEITUAN_PINCHANG = window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN_PINCHANG; // 美团微信小程序和美团拼场小程序跳转的地址 -- 美团内部小程序地址
          if (!(window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN || IS_WXAPP_MEITUAN_PINCHANG)) {
            _context.next = 25;
            break;
          }
          wxMtWebviewUrl = "/index/pages/h5/h5?weburl=" + encodeURIComponent(url);
          if (IS_WXAPP_MEITUAN_PINCHANG) {
            wxMtWebviewUrl = "/pages/webview/webview/index?weburl=" + encodeURIComponent(url);
          }
          wx.miniProgram.navigateTo({
            url: wxMtWebviewUrl,
            fail: function fail(e) {
              window.owl && window.owl('addError', {
                name: "\u7F8E\u56E2\u5C0F\u7A0B\u5E8F window.wx.miniProgram.navigateTo fail-".concat(e.errMsg),
                msg: {
                  miniUrl: miniUrl,
                  errro: e,
                  drip: window.Drip
                }
              }, {
                category: 'jsError',
                level: 'error'
              });
            }
          });
          return _context.abrupt("return");
        case 25:
          if (!UA.IS_DouyinShowMicroApp) {
            _context.next = 31;
            break;
          }
          result = url.match(/.*#\/detail\/(\d+).*/);
          _miniUrl = url;
          if (result && result[1] && /isNewPage=true/.test(url)) {
            // 项目详情页面跳转, 旧的项目详情地址
            _miniUrl = "/pages/show/detail/index?id=".concat(result[1], "&isNewPage=true");
          }
          if (_miniUrl.startsWith('/pages')) {
            window.tt.miniProgram.navigateTo({
              url: _miniUrl,
              fail: function fail(e) {
                window.owl && window.owl('addError', {
                  name: "\u6296\u97F3\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.tt.miniProgram.navigateTo fail-".concat(e.errMsg),
                  msg: {
                    miniUrl: _miniUrl,
                    error: e,
                    drip: window.Drip
                  }
                }, {
                  category: 'jsError',
                  level: 'error'
                });
              }
            });
          } else {
            location.href = _miniUrl;
          }
          return _context.abrupt("return");
        case 31:
          if (!(UA.IS_MAOYAN_XHS_APP || UA.IS_MAOYAN_XHSMOVIE)) {
            _context.next = 35;
            break;
          }
          // const result = url.match(/.*#\/detail\/(\d+).*/)
          _miniUrl2 = "/pages/show/webview/webview?url=" + encodeURIComponent(url); // if (result && result[1]) {
          //   // 项目详情页面跳转, 旧的项目详情地址
          //   miniUrl = `/pages/show/detail/index?id=${result[1]}`
          // }
          window.xhs.miniProgram.navigateTo({
            url: _miniUrl2,
            fail: function fail(e) {
              window.owl && window.owl('addError', {
                name: "\u5C0F\u7EA2\u4E66\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.xhs.miniProgram.navigateTo fail-".concat(e.errMsg),
                msg: {
                  miniUrl: _miniUrl2,
                  errro: e,
                  drip: window.Drip
                }
              }, {
                category: 'jsError',
                level: 'error'
              });
            }
          });
          return _context.abrupt("return");
        case 35:
          if (!UA.IS_MAOYAN_BAIDU_APP) {
            _context.next = 39;
            break;
          }
          // const result = url.match(/.*#\/detail\/(\d+).*/)
          _miniUrl3 = "/pages/show/webview/webview?url=" + encodeURIComponent(url); // if (result && result[1]) {
          //   // 项目详情页面跳转, 旧的项目详情地址
          //   miniUrl = `/pages/show/detail/index?id=${result[1]}`
          // }
          window.swan.webView.navigateTo({
            url: _miniUrl3,
            fail: function fail(e) {
              window.owl && window.owl('addError', {
                name: "\u767E\u5EA6\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.xhs.miniProgram.navigateTo fail-".concat(e.errMsg),
                msg: {
                  miniUrl: _miniUrl3,
                  errro: e,
                  drip: window.Drip
                }
              }, {
                category: 'jsError',
                level: 'error'
              });
            }
          });
          return _context.abrupt("return");
        case 39:
          if (!UA.IS_BiliShowMicroApp) {
            _context.next = 43;
            break;
          }
          _miniUrl4 = "/pages/show/webview/webview?url=" + encodeURIComponent(encodeURIComponent(url));
          window.bl.miniProgram.navigateTo({
            url: _miniUrl4,
            fail: function fail(e) {
              window.owl && window.owl('addError', {
                name: "b\u7AD9\u6F14\u51FA\u5C0F\u7A0B\u5E8F window.bl.miniProgram.navigateTo fail-".concat(e.errMsg),
                msg: {
                  miniUrl: _miniUrl4,
                  errro: e,
                  drip: window.Drip
                }
              }, {
                category: 'jsError',
                level: 'error'
              });
            }
          });
          return _context.abrupt("return");
        case 43:
          if (UA.isNative && url.includes('closekey')) {
            _Url$parse6 = Url.parse(url), _uri4 = _Url$parse6.uri, _hash4 = _Url$parse6.hash, _query4 = _Url$parse6.query;
            _query4.closekey = Url.getHashQuery('closekey', url);
            /* eslint-disable-next-line no-param-reassign */
            url = Url.stringify(_uri4, _query4, _hash4);

            // 解决KNB.closePageWithKeys在点评iOS上不生效问题
            // https://km.sankuai.com/page/1303599853
            if (UA.IS_DIANPING && UA.osName === 'ios') {
              /* eslint-disable-next-line no-param-reassign */
              if (IS_TICKET_STRATEGY_PAGE || IS_PRE_TICKET_V2_PAGE) {
                queryStr = '&notitlebar=1&future=2';
                url = "imeituan://www.meituan.com/web?noquery=1&notitlebar=1&future=2&url=".concat(encodeURIComponent(url + queryStr));
              } else {
                url = "imeituan://www.meituan.com/web?url=".concat(encodeURIComponent(url));
              }
            }
          }
          if (!(isLocal || !UA.isNative || /^(dianping|imeituan):\/\//.test(url))) {
            _context.next = 47;
            break;
          }
          // 本地 或者 非Native环境 或者 带协议的链接 直接跳转
          location.href = url;
          return _context.abrupt("return");
        case 47:
          if (_blank === undefined) _blank = true;
          qs = {
            noquery: 1
          };
          if (!(UA.isNative && _blank)) {
            _context.next = 144;
            break;
          }
          _queryStr = '&notitlebar=1&future=2'; // 新日历页&分享晒单页 美团、点评、猫眼渠道均隐藏native导航栏，h5自渲染导航栏样式
          if (!(IS_NEW_CALENDAR_PAGE || IS_SHARE_ORDER_PAGE || IS_TICKET_STRATEGY_PAGE || IS_PRE_TICKET_V2_PAGE)) {
            _context.next = 71;
            break;
          }
          if (!UA.IS_DIANPING) {
            _context.next = 58;
            break;
          }
          _url = 'dianping://web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + _queryStr);
          aEl = document.createElement('a');
          aEl.href = _url;
          aEl.click();
          return _context.abrupt("return");
        case 58:
          if (!UA.IS_MAOYAN) {
            _context.next = 65;
            break;
          }
          if (!compareVersions(UA.appVersion, '9.57.0')) {
            _context.next = 65;
            break;
          }
          _url2 = 'maoyan://maoyan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + _queryStr);
          _aEl = document.createElement('a');
          _aEl.href = _url2;
          _aEl.click();
          return _context.abrupt("return");
        case 65:
          if (!UA.IS_MEITUAN) {
            _context.next = 71;
            break;
          }
          _url3 = 'imeituan://www.meituan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + _queryStr);
          _aEl2 = document.createElement('a');
          _aEl2.href = _url3;
          _aEl2.click();
          return _context.abrupt("return");
        case 71:
          if (!IS_SHOW_HOME_PAGE) {
            _context.next = 93;
            break;
          }
          if (!UA.IS_MAOYAN) {
            _context.next = 79;
            break;
          }
          if (!compareVersions(UA.appVersion, '9.57.0')) {
            _context.next = 79;
            break;
          }
          _url4 = 'maoyan://maoyan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + _queryStr);
          _aEl3 = document.createElement('a');
          _aEl3.href = _url4;
          _aEl3.click();
          return _context.abrupt("return");
        case 79:
          if (!UA.IS_MEITUAN) {
            _context.next = 86;
            break;
          }
          if (!compareVersions(UA.appVersion, '12.22.200')) {
            _context.next = 86;
            break;
          }
          _url5 = 'imeituan://www.meituan.com/web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + _queryStr);
          _aEl4 = document.createElement('a');
          _aEl4.href = _url5;
          _aEl4.click();
          return _context.abrupt("return");
        case 86:
          if (!UA.IS_DIANPING) {
            _context.next = 93;
            break;
          }
          if (!compareVersions(UA.appVersion, '11.24.0')) {
            _context.next = 93;
            break;
          }
          _url6 = 'dianping://web?noquery=1&notitlebar=1&future=2&url=' + encodeURIComponent(url + _queryStr);
          _aEl5 = document.createElement('a');
          _aEl5.href = _url6;
          _aEl5.click();
          return _context.abrupt("return");
        case 93:
          if (!(UA.IS_DIANPING && UA.osName === 'ios')) {
            _context.next = 109;
            break;
          }
          _context.prev = 94;
          _context.next = 97;
          return Drip.getStore("lion-store-myWebview");
        case 97:
          lionStoreMyWebviewConfig = _context.sent;
          if (!(lionStoreMyWebviewConfig && lionStoreMyWebviewConfig.isUseMyWebviewInDP)) {
            _context.next = 105;
            break;
          }
          if (!isUseNewWebviewForSSL(url)) {
            _context.next = 105;
            break;
          }
          url = "dianping://myshowweb?noquery=1&url=" + encodeURIComponent(url);
          a = document.createElement('a');
          a.href = url;
          a.click();
          return _context.abrupt("return");
        case 105:
          _context.next = 109;
          break;
        case 107:
          _context.prev = 107;
          _context.t0 = _context["catch"](94);
        case 109:
          if (!UA.IS_MEITUAN) {
            _context.next = 135;
            break;
          }
          // wkwebview 切换

          try {
            needWkWebview = KNB.Semver.gte(UA.appVersion, '9.10.6');
          } catch (e) {
            console.error(e);
          }
          if (!jump) {
            _context.next = 115;
            break;
          }
          return _context.abrupt("return", KNB.jumpWebview({
            url: url,
            qs: Object.assign({}, qs, {
              wkwebview: needWkWebview ? 1 : 0
            })
          }));
        case 115:
          _context.prev = 115;
          _context.next = 118;
          return Drip.getStore("lion-store-myWebview");
        case 118:
          _lionStoreMyWebviewConfig = _context.sent;
          if (!(_lionStoreMyWebviewConfig && _lionStoreMyWebviewConfig.isUseMyWebviewInMT)) {
            _context.next = 126;
            break;
          }
          if (!isUseNewWebviewForSSL(url)) {
            _context.next = 126;
            break;
          }
          url = "imeituan://www.meituan.com/movieweb?noquery=1&url=" + encodeURIComponent(url);
          _a = document.createElement('a');
          _a.href = url;
          _a.click();
          return _context.abrupt("return");
        case 126:
          _context.next = 130;
          break;
        case 128:
          _context.prev = 128;
          _context.t1 = _context["catch"](115);
        case 130:
          url = "imeituan://www.meituan.com/web?noquery=1".concat(needWkWebview ? '&wkwebview=1' : '', "&url=") + encodeURIComponent(url);
          _a2 = document.createElement('a');
          _a2.href = url;
          _a2.click();
        case 134:
          return _context.abrupt("return");
        case 135:
          if (!(!jump && UA.IS_MAOYAN && UA.osName === 'android')) {
            _context.next = 141;
            break;
          }
          // 猫眼 android 跳转需要特殊处理， 手机端需要唤起摄像头
          if (KNBCore.compareVersion(UA.appVersion, '9.20.0') >= 0) {
            // android 9.20.0 版本后要把concert_verify参数放在url里
            urlObj = parseUrl(url, true);
            urlObj.set('query', Object.assign({}, urlObj.query, {
              concert_verify: 1
            }));
            url = urlObj.toString();
            url = "meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url));
          } else {
            url = "meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url), "#concert_verify");
          }
          _a3 = document.createElement('a');
          _a3.href = url;
          _a3.click();
          return _context.abrupt("return");
        case 141:
          if (!jump) {
            _context.next = 143;
            break;
          }
          return _context.abrupt("return", KNBP.jumpWebview({
            url: url
          }));
        case 143:
          return _context.abrupt("return", KNBP.openPage({
            url: url,
            qs: qs
          }));
        case 144:
          location.href = url;
        case 145:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[94, 107], [115, 128]]);
  }));
  return function redirect(_x) {
    return _ref.apply(this, arguments);
  };
}();
redirect.getUrl = getUrl;
export default redirect;